import FlexMasonry from "flexmasonry/src/flexmasonry.js";

window.addEventListener("load", () => {
  FlexMasonry.init(".js-grid-masonry", {
    responsive: false,
    numCols: 2,
  });
});
